/* Maison RM : menu mobile à deux onglets (Pièces / Maisons) + raccourcis bordeaux en bas (piste C validée).
   Construit à partir du menu Shopify existant : les entrées avec sous-menu deviennent des onglets,
   les entrées simples deviennent les raccourcis du bas. */
(function () {
  var css = [
    '.mrm-menu{display:flex;flex-direction:column;min-height:100%;font-family:var(--font-heading-family,"Archivo"),"Helvetica Neue",Arial,sans-serif}',
    '.mrm-menu__tabs{display:grid;grid-auto-flow:column;grid-auto-columns:1fr;border-bottom:1px solid #E3E0DE}',
    '.mrm-menu__tab{background:none;border:0;border-bottom:2px solid transparent;padding:14px 8px;font:inherit;font-size:12px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#6E6A69;cursor:pointer}',
    '.mrm-menu__tab[aria-selected="true"]{color:#5C1A24;border-bottom-color:#5C1A24}',
    '.mrm-menu__panel{list-style:none;margin:0;padding:8px 20px 24px}',
    '.mrm-menu__panel a{display:flex;justify-content:space-between;align-items:center;padding:15px 0;border-bottom:1px solid #EFEDEB;text-decoration:none;color:#111;font-size:19px;font-weight:800;text-transform:uppercase;font-stretch:78%;letter-spacing:.01em}',
    '.mrm-menu__panel a::after{content:"\\2192";font-weight:400;font-size:15px;color:#6E6A69}',
    '.mrm-menu__quick{margin-top:auto;display:flex;justify-content:space-between;gap:8px;background:#5C1A24;padding:16px 20px}',
    '.mrm-menu__quick a{color:#fff;text-decoration:none;font-size:11px;font-weight:600;letter-spacing:.14em;text-transform:uppercase}',
    '.mrm-menu-hidden{display:none!important}'
  ].join('');

  function build() {
    var nav = document.querySelector('.menu-drawer__navigation');
    if (!nav || nav.querySelector('.mrm-menu')) return;
    var list = nav.querySelector(':scope > ul');
    if (!list) return;

    var tabs = [];
    var quick = [];
    Array.prototype.forEach.call(list.children, function (li) {
      var details = li.querySelector(':scope > details');
      if (details) {
        var title = details.querySelector('summary').textContent.trim();
        var links = Array.prototype.map.call(details.querySelectorAll('.menu-drawer__submenu ul a'), function (a) {
          return { title: a.textContent.trim(), url: a.getAttribute('href') };
        });
        tabs.push({ title: title, links: links });
      } else {
        var a = li.querySelector('a');
        if (a) quick.push({ title: a.textContent.trim(), url: a.getAttribute('href') });
      }
    });
    if (!tabs.length) return;

    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    var root = document.createElement('div');
    root.className = 'mrm-menu';
    var tablist = document.createElement('div');
    tablist.className = 'mrm-menu__tabs';
    tablist.setAttribute('role', 'tablist');
    root.appendChild(tablist);

    tabs.forEach(function (t, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mrm-menu__tab';
      btn.id = 'mrm-tab-' + i;
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-controls', 'mrm-panel-' + i);
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.textContent = t.title;
      tablist.appendChild(btn);

      var panel = document.createElement('ul');
      panel.className = 'mrm-menu__panel';
      panel.id = 'mrm-panel-' + i;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', btn.id);
      panel.hidden = i !== 0;
      t.links.forEach(function (l) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = l.url;
        a.textContent = l.title;
        li.appendChild(a);
        panel.appendChild(li);
      });
      root.appendChild(panel);

      btn.addEventListener('click', function () {
        tablist.querySelectorAll('[role="tab"]').forEach(function (b, j) {
          b.setAttribute('aria-selected', j === i ? 'true' : 'false');
          root.querySelector('#mrm-panel-' + j).hidden = j !== i;
        });
      });
    });

    if (quick.length) {
      var bar = document.createElement('div');
      bar.className = 'mrm-menu__quick';
      quick.forEach(function (q) {
        var a = document.createElement('a');
        a.href = q.url;
        a.textContent = q.title;
        bar.appendChild(a);
      });
      root.appendChild(bar);
    }

    list.classList.add('mrm-menu-hidden');
    nav.appendChild(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
